import { Injectable } from '@angular/core';

/**
 * This is the client-side code that uses the inferred types from the server
 */
import { createTRPCProxyClient, httpLink } from '@trpc/client';
import { AppRouter } from '../../../../../express-tRPC/src/app';
import {environment} from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { CookieData } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TrpcService {

  public currentLocationObservable = new BehaviorSubject('');
  public resetTimerObservable = new BehaviorSubject(false);

  /**
   * Indicates when tRPC is ready to be used
   */
  trpcReady = new Promise((resolve, reject) => {

    // Poll until the token has been set
    const checkToken = () => {
      if (this.tokenSet === true) {
        // console.log(`trpcReady resolving now`, this.token);
        resolve(true);
      } else {
        setTimeout(checkToken, 100); // Check every 100ms
      }
    };

    checkToken();
  });

  // setToken = function(newToken: string) {
  //   console.log(`Set token called`, newToken);
  //   // this.token = newToken;
  // }

  // Default token if none specified by client
  private token: string = '';

  // Indicates that the token has been set
  private tokenSet = false;

  // When IIS is used in proxy mode if this is much larger IIS will return a 400 bad request
  // response if the URL is too long. v11 of tRPC has `methodOverride: 'POST'` to send the requests using POST
  // instead of GET. https://trpc.io/docs/client/links/httpBatchLink
  TRPC_MAX_URL_LENGTH = 850;

  TRPC_ENDPOINT_URL = environment.TRPC_ENDPOINT_URL;

  myOpts = {
    url: this.TRPC_ENDPOINT_URL,
    token: this.token,
    maxURLLength: this.TRPC_MAX_URL_LENGTH,
    resetTimerObservable: this.resetTimerObservable,
    headers() {
      return {
        // This will be the default token unless setToken() is called
        Authorization: this.token
      };
    },
    async fetch(input: RequestInfo | URL, init?: RequestInit) {

      const response = await fetch(input, init);
      // this.resetTimerObservable.next(true);

      return response;

    },
  };

  trpc = createTRPCProxyClient<AppRouter>({
    links: [
      httpLink(this.myOpts),
    ],
  });

  constructor() {
    console.log(`trpc.service constructor called, auth header is ${this.token}`);
  }

  /**
   *  When called will create or re-create the tRPC service with the new auth token.
   * @param newToken
   */
  setToken(cookieData: CookieData) {
    console.log(`Set token called`, cookieData?.cookie?.value);

    const newToken = cookieData?.cookie?.value || undefined;
    const cookieName = cookieData?.cookie?.name || undefined;
    const resetTimerObservable = this.resetTimerObservable;

    const opts = {

      url: this.TRPC_ENDPOINT_URL,
      maxURLLength: this.TRPC_MAX_URL_LENGTH,

      headers() {
        return {
          Authorization: newToken,
          AuthName: cookieName
        };
      },
      async fetch(input: RequestInfo | URL, init?: RequestInit) {

        const response = await fetch(input, init);
        resetTimerObservable.next(true);
        return response;

      },
    }

    // Indicate that the token has been set so any processes waiting for tRPC can proceed
    this.tokenSet = true;

    if(newToken !== this.token) {

      // We want to know when this is called and what the token is
      // console.log(`tRPC creating new service for new token`);
      // console.log(`newToken: ${newToken}`);
      // console.log(`this.token: ${this.token}`);
      // console.log(`opts:`, opts);
      // console.log(`opts:`, opts.headers().Authorization);



        this.trpc = createTRPCProxyClient<AppRouter>({
          links: [
            httpLink(opts),
          ],
        });

        if(newToken) {
          //call get get current location to display on pages
          this.trpc.lots.getSessionLID.query().then((data: any) => {
            this.currentLocationObservable.next(data);
          })
        }

    } else {
      console.log(`not creating new service. Token unchanged.`);
    }

  }

}
